module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-portal-1.d1a925b1.svg";